<template>
    <section>
        <form @submit.prevent="confirm">
            <h2 class="title pink">Privacy Settings</h2>
            <hr/>
            <div class="form-group">
                <b-form-checkbox
                    id="privacy_2"
                    v-model="form.privacy_2"
                    name="privacy_2"
                    value="accepted"
                    unchecked-value="not_accepted"
                    @input="changeHandler"
                    >
                    I declare to have duly read and understood the information relating to the processing of personal data provided by {{ this.$strings.us }}. 
                    (downloadable <download what="privacy_2"/>), and I consent to the processing of special categories of personal data for the purpose of data processing.
                </b-form-checkbox>
            </div>
            <hr />
            <div class="form-group">
                <b-form-checkbox
                    id="privacy_axa_2"
                    v-model="form.privacy_axa_2"
                    name="privacy_axa_2"
                    value="accepted"
                    unchecked-value="not_accepted"
                    @input="changeHandler"
                    >
                    I declare to have duly read the information required by the European Regulation 2016/679 on the protection of personal data provided by 
                    {{ this.$strings.partner }} (downloadable <download what="privacy_axa"/>), to have taken note of its contents, and agree 
                    to the processing of my data, including special categories of personal data, for insurance purposes relating to the specific contractual 
                    relationship between the Insured and the Insurance Company according to the methods specified in the downloadable files
                </b-form-checkbox>
            </div>
            <hr />
            <div class="row-btn">
                <button type="submit" class="btn btn-primary">Confirm</button>
            </div>											
        </form>
        <b-modal ref="modal-policy-alert" centered title="Are you sure?">
            <p>
                If your consent to processing of sensitive data is withdrawn, it will no longer be possible to open a claim.<br/>
                Do you confirm that you want to revoke you consent to the processing of sensitive data?
            </p>
        </b-modal>
    </section>                
</template>

<script>
//import { mapFields } from 'vuex-map-fields';

export default {
    data(){
        return {
            consensum: false,
            form: {
                privacy_2: (this.$store.state.privacy != null) ? this.$store.state.privacy.privacy_2 : "not_accepted",
                privacy_axa_2: (this.$store.state.privacy != null) ? this.$store.state.privacy.privacy_axa_2 : "not_accepted",
            },
        }
    },
    computed: {
        fullName(){
            return this.$store.state.userInfo.name
        },
    },
    methods: {
        /* 
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty && $error==true ? !$error : null;
        }, 
        */
        changeHandler: function(checked){
            if(!this.consensum && checked == "not_accepted"){
                this.$bvModal.msgBoxConfirm('If your consent to processing of sensitive data is withdrawn, it will no longer be possible to open a claim.\nDo you confirm that you want to revoke you consent to the processing of sensitive data?', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then((choiche) => {
                    if(choiche){
                        //console.log("ok");
                        this.consensum = true;
                    } else {
                        //console.log("no");
                        this.form = {
                            privacy_2: (this.$store.state.privacy != null) ? this.$store.state.privacy.privacy_2 : "not_accepted",
                            privacy_axa_2: (this.$store.state.privacy != null) ? this.$store.state.privacy.privacy_axa_2 : "not_accepted",
                        }
                    }
                })
                .catch(() => {
                    //console.log("msgBoxConfirm err", err);
                });
            }
        },
        confirm: function(){
            this.$store.dispatch('acceptPrivacy',this.form);                
        },
        
    }
}
</script>